<template>
<div style="min-width:1200px;margin:0 auto;">
  <personal-header :configData="configData"></personal-header>
  <div style="width: 100%;;background: #f4f4f4;">

    <div style="display: flex;width: 1200px;min-height:768px;margin: 0 auto;background:#fff;flex-direction: column;" id="person">
      <router-view></router-view>
    </div>
  </div>
  <footer-vue :configData="configData"></footer-vue>
</div>

</template>
<script>
import FooterVue from "../FooterVue";
import PersonalHeader from "./findPassHead";
export default {
  components: {
    FooterVue,
    PersonalHeader
  },
  data() {
    return {
      activeIndex: "1",
      configData: ""
    };
  },
  methods: {
    incrementTotal(val) {
      this.activeIndex = val;
    },
    // 获取全局配置信息
    getConfig() {
      this.$ajax
        .post(this.pathUrl("/globleWeb/getSysSetList"), this.postData({}))
        .then(res => {
          this.configData = res.data[0];
          // document.title = res.data[0].webname;
        });
    }
  },
  created() {
    this.getConfig();
  }
};
</script>
<style lang="scss">
#person {
  top: 0;
  .content {
    // width: 1200px;
    min-height: 400px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/findPass/app.vue